import { addMethod, string } from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

declare module 'yup' {
  interface StringSchema {
    phoneValid(): StringSchema;
  }
}

const e164Regex = /^\+[1-9]\d{1,14}$/;

addMethod(string, 'phoneValid', function format() {
  return this.test('phoneValid', 'phoneValid', function (value) {
    return e164Regex.test(value) && isValidPhoneNumber(value);
  });
});
